(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[229],{

/***/ 77183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home",
      function () {
        return __webpack_require__(62692);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 7 modules
var useTranslation = __webpack_require__(26524);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(7360);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Home/AnimatedLine/index.tsx


/**
 * @return{svg} animated line
 */ function AnimatedLine(param) {
    let {} = param;
    const [elementclientHeight, setElementclientHeight] = (0,react.useState)("");
    const [elementscrollHeight, setElementscrollHeight] = (0,react.useState)("");
    const [bodyscrollTop, setBodyscrollTop] = (0,react.useState)("");
    const [elementscrollTop, setElementscrollTop] = (0,react.useState)("");
    const pathLength = "1000";
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    });
    const handleScroll = ()=>{
        setElementclientHeight(document.documentElement.clientHeight.toString());
        setElementscrollHeight(document.documentElement.scrollHeight.toString());
        setBodyscrollTop(document.body.scrollTop.toString());
        setElementscrollTop(document.documentElement.scrollTop.toString());
    };
    const scrollPercentage = (parseInt(elementscrollTop) + parseInt(bodyscrollTop)) / (parseInt(elementscrollHeight) - parseInt(elementclientHeight));
    let drawLength = 0;
    if (scrollPercentage >= 0) {
        drawLength = parseInt(pathLength) * scrollPercentage;
    }
    const strokeDashOffset = parseInt(pathLength) - drawLength;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed top-0 left-0 w-full h-full overflow-hidden text-center pointer-events-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "relative inline-block h-full z-[5]",
            preserveAspectRatio: "xMidYMax meet",
            viewBox: "0 0 533 3995",
            fill: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "stroke-animatedline",
                d: "M 331.001 0 C 331.001 562 331.001 727.833 331.001 740.5 V 821 V 871 V 902.5 V 920 V 950.5 V 977 C 331.001 977 352.5 1011.5 331.001 1030.5 C 309.502 1049.5 138 1189 331.001 1252.5 C 524.002 1316 664.502 1533 331.001 1514 C -2.49963 1495 593.502 1902 331.001 2150 C 68.5004 2398 535.001 2240 456 2386.5 C 376.999 2533 -72.9999 2416.5 11.0001 2562.5 C 95.0001 2708.5 286.002 2822 331.001 2877 C 376 2932 343.5 3108 331.001 3170 C 318.502 3232 331.001 3471.5 331.001 3471.5 V 3702 V 3994.5",
                strokeWidth: "7",
                strokeDashoffset: strokeDashOffset + "",
                strokeDasharray: parseInt(pathLength) + " " + parseInt(pathLength),
                pathLength: "1000"
            })
        })
    });
}
/* harmony default export */ var Home_AnimatedLine = (AnimatedLine);

// EXTERNAL MODULE: ./src/components/Icons/index.tsx + 54 modules
var Icons = __webpack_require__(66739);
// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/constants/index.mjs
var constants = __webpack_require__(34534);
// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/entities/index.mjs
var entities = __webpack_require__(79334);
// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/enums/index.mjs
var enums = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/functions/index.ts + 3 modules
var functions = __webpack_require__(83554);
// EXTERNAL MODULE: ./src/components/Badge/index.ts + 1 modules
var Badge = __webpack_require__(47743);
// EXTERNAL MODULE: ./src/components/Currency/index.ts + 2 modules
var Currency = __webpack_require__(50731);
// EXTERNAL MODULE: ./src/components/Loader/index.tsx + 2 modules
var Loader = __webpack_require__(62817);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceToNow/index.js + 28 modules
var formatDistanceToNow = __webpack_require__(94513);
// EXTERNAL MODULE: ./src/hooks/index.ts + 1 modules
var hooks = __webpack_require__(87808);
;// CONCATENATED MODULE: ./src/components/TimeAgo.tsx




const TimeAgo = (param)=>{
    let { date  } = param;
    const [distance, setDistance] = (0,react.useState)((0,formatDistanceToNow/* default */.Z)(date, {
        addSuffix: true,
        includeSeconds: true
    }));
    (0,hooks/* useInterval */.Yz)(()=>{
        setDistance((0,formatDistanceToNow/* default */.Z)(date, {
            addSuffix: true,
            includeSeconds: true
        }));
    }, 1000);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: distance
    });
};

;// CONCATENATED MODULE: ./src/components/NotificationCentre/Notification.tsx














const STARGATE_TOKEN = new entities/* Token */.WU({
    chainId: enums/* ChainId.SMARTBCH */.a_.SMARTBCH,
    address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
    decimals: 18,
    symbol: "STG",
    name: "StargateToken"
});
const Notification = (param)=>{
    let { data , showExtra =false , hideStatus =false  } = param;
    const notification = JSON.parse(data);
    const { status  } = (0,dist/* useWaitForTransaction */.BX)({
        chainId: notification.chainId,
        hash: notification.txHash
    });
    if (!status) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-5 px-4 pr-8 rounded-2xl min-h-[82px] w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-full bg-slate-600 h-9 w-9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-full gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-full gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-slate-500 w-full h-[12px] animate-pulse rounded-full"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-slate-500 w-[60px] h-[12px] animate-pulse rounded-full"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-slate-600 w-[120px] h-[10px] animate-pulse rounded-full"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative hover:opacity-80",
        children: [
            showExtra && /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Button */.p.Button, {
                className: "absolute right-3 top-0 bottom-0 z-[100]",
                children: (param)=>{
                    let { open  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                        as: "div",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronDownIcon */.v4, {
                            width: 20,
                            height: 20,
                            className: (0,functions/* classNames */.AK)(open ? "rotate-180" : "rotate-0", "rounded-full transition-all delay-200")
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: notification.href ? notification.href : constants/* chains */.p5[notification.chainId].getTxUrl(notification.txHash),
                className: "!no-underline",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,functions/* classNames */.AK)(showExtra ? "pr-10" : "pr-4", "relative cursor-pointer flex items-center gap-5 rounded-2xl px-4 py-3"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            badgeContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NetworkIcon */.dF, {
                                chainId: notification.chainId,
                                width: 18,
                                height: 18
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-2 bg-slate-600 rounded-full h-[36px] w-[36px] flex justify-center items-center",
                                children: [
                                    !hideStatus && (status === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Spinner */.a.Spinner, {}) : status === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Close */.x8, {
                                        width: 20,
                                        height: 20,
                                        className: "text-red-400"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})),
                                    (status === "success" || notification.summary.info) && notification.type === "send" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightIcon */.XC, {
                                        width: 20,
                                        height: 20
                                    }),
                                    (status === "success" || notification.summary.info) && notification.type === "stargate" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Currency/* Currency.Icon */.F.Icon, {
                                        currency: STARGATE_TOKEN,
                                        width: 20,
                                        height: 20
                                    }),
                                    (status === "success" || notification.summary.info) && notification.type === "swap" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowsUpDownIcon */.uV, {
                                        width: 20,
                                        height: 20
                                    }),
                                    (status === "success" || notification.summary.info) && notification.type === "approval" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* LockOpenIcon */.Gl, {
                                        width: 20,
                                        height: 20
                                    }),
                                    (status === "success" || notification.summary.info) && notification.type === "mint" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* PlusIcon */.pO, {
                                        width: 20,
                                        height: 20
                                    }),
                                    (status === "success" || notification.summary.info) && notification.type === "burn" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* FireIcon */.Yq, {
                                        width: 20,
                                        height: 20
                                    }),
                                    (status === "success" || notification.summary.info) && notification.type === "claimRewards" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BanknotesIcon */.YI, {
                                        width: 20,
                                        height: 20
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-0.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center gap-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "items-center text-sm font-medium whitespace-normal text-slate-50",
                                        children: notification.summary.info ? notification.summary.info : [
                                            "loading"
                                        ].includes(status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Dots */.a.Dots, {
                                            children: notification.summary.pending
                                        }) : status === "error" ? notification.summary.failed : notification.summary.completed
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs text-slate-500",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeAgo, {
                                        date: new Date(notification.timestamp)
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/NotificationCentre/NotificationGroup.tsx



const NotificationGroup = (param)=>{
    let { notifications  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        children: (param)=>{
            let { open  } = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    notifications.length > 1 && open && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-[33px] top-7 bottom-7 w-0.5 bg-gradient-to-b from-slate-700 to-blue-500"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification, {
                        data: notifications[0],
                        showExtra: notifications.length > 1
                    }),
                    notifications.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                        children: notifications.map((el, idx)=>{
                            if (idx > 0) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification, {
                                    data: el,
                                    hideStatus: true
                                }, idx);
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/NotificationCentre/index.ts



;// CONCATENATED MODULE: ./src/components/Layout/Account/Transactions.tsx





const Transactions = (param)=>{
    let { notifications , clearNotifications  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid items-center h-12 grid-cols-3 px-2 border-b border-slate-200/20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronLeft */.s$, {
                                width: 24,
                                height: 24,
                                className: "text-slate-400"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-semibold text-slate-400",
                        children: "Transactions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-end justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: clearNotifications,
                            variant: "empty",
                            size: "sm",
                            className: "!p-0",
                            children: "Clear all"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-3 max-h-[300px] scroll",
                children: Object.entries(notifications).length > 0 ? Object.entries(notifications).reverse().map((param, index)=>{
                    let [, notifications] = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationGroup, {
                        notifications: notifications
                    }, index);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "py-5 text-sm text-center text-slate-500",
                    children: "Your transactions will appear here"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Tooltip/index.tsx
var Tooltip = __webpack_require__(54218);
// EXTERNAL MODULE: ./src/state/application/hooks.ts
var application_hooks = __webpack_require__(91475);
// EXTERNAL MODULE: ./src/state/user/hooks.tsx
var user_hooks = __webpack_require__(8350);
// EXTERNAL MODULE: ./src/wagmi/hooks/useActiveWeb3React.ts + 1 modules
var useActiveWeb3React = __webpack_require__(32553);
;// CONCATENATED MODULE: ./src/pages/home/index.tsx






// import LoaderDots from '../../components/LoaderDots'








/**
 * Home Page of the Application
 * @return {JSX.Element}
 */ function Home() {
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    const [chainIdcurrent] = (0,application_hooks/* useSessionChainId */.or)();
    const { chainId , chain  } = (0,useActiveWeb3React/* default */.Z)();
    const { address  } = (0,dist/* useAccount */.mA)();
    const [notfications, { clearNotifications  }] = (0,user_hooks/* useNotifications */.zn)(address);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Home | EmberSwap"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "EmberSwap"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid max-w-screen-xl grid-cols-1 gap-2 p-4 m-auto z-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            t("Welcome to EmberSwap"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Spinner */.a.Spinner, {
                                className: "bg-green-400",
                                children: "asdaasda"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Dots */.a.Dots, {
                                className: "bg-green-400",
                                children: "asdaasda"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Transactions, {
                        notifications: notfications,
                        clearNotifications: clearNotifications
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative flex flex-row text-green-500 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                placement: "right",
                                panel: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "2131231231231231312312312312"
                                }),
                                button: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-red-500 bg-green-500",
                                    children: "test"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "relative z-[5]",
                                size: "md",
                                variant: "outlined",
                                color: "red",
                                children: [
                                    "tssest",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " left-0 right-0 z-[2] w-full absolute bg-gradient-to-tl from-yellow-400/70 transition-all duration-1000 via-orange-500/70 to-red-600/70 bg-pos-0 bg-size-200 hover:bg-pos-100 h-[52px] rounded-2xl"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: chainIdcurrent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: chainId
                    }),
                    new Date().getFullYear(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    new Date().getMonth(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    new Date().getDay(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    new Date().getHours(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    new Date().getMinutes(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    new Date().getSeconds(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    JSON.stringify(new Date()),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: JSON.stringify(chain)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SearchIcon */.W1, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* XCircleIcon */.oO, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ExternalLinkIcon */.h0, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CodeIcon */.dN, {
                        width: 20,
                        height: 20,
                        className: "text-gray-100 hover:text-black"
                    }),
                    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis?",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "https://emberswap.com/img/candlesticks2.png",
                        alt: "HEJ",
                        className: "w-full h-full",
                        width: 494,
                        height: 931
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "one",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "scroll",
                            "data-rate": ".4",
                            "data-direction": "vertical",
                            children: "HALLO"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "two",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "scroll",
                                "data-rate": ".2",
                                "data-direction": "vertical"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: " big watermark"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center mb-4 font-medium text-red-900 title-font md:mb-0",
                        children: "TailWind CSS"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "randomtest tempcointainer",
                        children: " SASS CSS"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "title",
                        children: [
                            "Welcome to ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://nextjs.org",
                                children: "Next.js!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "description",
                        children: [
                            "Get started by editing ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                className: "code",
                                children: "pages/index.js"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "https://nextjs.org/docs",
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Documentation →"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Find in-depth information about Next.js features and API."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "https://nextjs.org/learn",
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Learn →"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Learn about Next.js in an interactive course with quizzes!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "https://github.com/vercel/next.js/tree/master/examples",
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Examples →"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Discover and deploy boilerplate example Next.js projects."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_AnimatedLine, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [792,513,354,774,888,179], function() { return __webpack_exec__(77183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);